import { Box, styled, Typography } from "@mui/material";
import theme from "../theme";

export const HEADER_AND_TAB_HEIGHT = 130;

export const ChatInfoWrapper = styled(Box)`
  background: ${({ theme }) => theme.palette.background.default};
`;

export const ChatInfoPanelTitle = styled(Typography)`
  color: ${theme.palette.text.secondary};
`;
